import * as ActionType from "./auditLog.type";

const initialState = {
  auditLogs: [],
  total: 0,
  stats: {},
  leaderboard: [],
  leaderboardTotal: 0,
};

export const auditLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_AUDIT_LOGS:
      return {
        ...state,
        auditLogs: action.payload.data,
        total: action.payload.total,
      };
    case ActionType.GET_AUDIT_STATS:
      return { ...state, stats: action.payload };
    case ActionType.GET_COIN_LEADERBOARD:
      return {
        ...state,
        leaderboard: action.payload.data,
        leaderboardTotal: action.payload.total,
      };
    default:
      return state;
  }
};
